import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Helpers from "../../global/Helpers";
import * as Constants from "../../constants/Constants";
import {OrderCategory} from "../../constants/Constants";
import DatePicker from "react-date-picker";

function BracketOrdersPopup(props) {
  const { i18n } = useTranslation();
  const [isTakeProfit, setIsTakeProfit] = useState(false);
  const [AsMktTakeProfit, setAsMktTakeProfit] = useState(false);
  const [isStopLoss, setIsStopLoss] = useState(false);
  const [AsMktStopLoss, setAsMktStopLoss] = useState(false);
  const [TPValue, setTPValue] = useState("");
  const [STValue, setSTValue] = useState("");
  const [STSelectedCriteria, setSTSelectedCriteria] = useState("0");
  const [TPSelectedCriteria, setTPSelectedCriteria] = useState("0");
  const [Quantity, setQuantity] = useState(props.OrderDetailsData.Qty);
  const [SymbolSelected, setSymbolSelected] = useState(props.OrderDetailsData.Symbol);
  const [price, setPrice] = useState(Helpers.threeDigitFormatValue(props.OrderDetailsData.PCost));
  // const [BracketOrderSelected, setBracketOrderSelected] = useState("1");
  const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;

  function callAddOrder() {
    if (!validate()) {
      return;
    }
    ;
    const newdate = new Date();
    const newDate2 = newdate.setFullYear(newdate.getFullYear() + 1);
    var x = Helpers.dateFrommater(new Date(newDate2));
    if (isTakeProfit) {
      let order = {};

      let user = JSON.parse(localStorage.getItem("user"));
      //let selectedAccount = props.selectedAccount;
      let newDate = new Date();

      let date = Helpers.dateFrommater(newDate);

      let result = props.symbols.find((obj) => {
        return obj.Symbol === props.OrderDetailsData.Symbol;
      });
      if (result !== undefined && result !== null) {
        order.SymbolCode = result.SymbolID;
        order.Exchange = result.Exchange;
        order.Symbol = result.Symbol;
        order.MarketTypeCode = result.MarketType; // symbol.MarketType
      } else {
        order.SymbolCode = "";
        order.Exchange = "";
        order.Symbol = "";
        order.MarketTypeCode = "";
      }

      order.OrderID = "";

      order.BookCode = "0001";
      order.BrokerID = user.BrokerID;
      order.AccountID = props.selectedAccount.AccountID;

      order.Price = String(price);
      order.ValidityCode = "0002";

      order.ValidityDate = Helpers.dateFrommater(new Date(newDate2));

      let total = Quantity;
      let remaining = Quantity;
      let execqty = 0;

      order.TotalVolume = String(total);
      order.Remaining = String(remaining);

      /* order.TotalVolume = String(parseInt(Quantity))
            order.Remaining = isModify ? remaining : String(parseInt(Quantity)); */
      //
      order.SourceCode = "c";
      order.StatusCode = "M"; //isCancel ? "C" : "W";
      order.EntryDate = date; // bs iza new order
      order.ModifyDate = /* isModify ? */ date; /* : "" */ // bs iza modify order
      order.UserID = user.UCode;
      order.OrigUserID = user.UCode;

      order.Source2Code = "c";
      order.MinFillQty = "0";
      //order.VisibleQty = thisParam.state.VisibleQty;

      order.VisibleQty = "0"; //thisParam.state.selectedExecutionRole === "0020" && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? -1 : thisParam.state.VisibleQty; //Mustafa changes

      order.OrderTypeCode = "2";
      if (order.Price === "0") {
        order.OrderTypeCode = "1";
      }
      order.NIN = props.selectedAccount.NIN;
      order.ProcSentFlag = "Y";
      order.MarketOrderID = "";
      order.OriginCode = "22";
      order.IntOrderID = "";
      order.TP_price = "";
      order.SL_price = "";

      order.TrxnID = "0";

      order.SellBuyFlag = "S";
      order.msgCode = "C10";

      order.AccountNameA = props.selectedAccount.ClientNameA;
      order.AccountNameE = props.selectedAccount.ClientNameE; // account.ClientNameE
      order.Remark = "Cost Price = " + order.Price; // remarks
      order.SenderSubID = "";
      order.BuyerMember = "";
      order.SellerMember = "";
      order.AvgExePrice = "";
      order.IsinCode = ""; // symbol.IsinCode
      order.FIXOrderID = "";
      order.ClientID = props.selectedAccount.ClientID;
      //order.ClientID = props.selectedAccount.AccountID;
      order.RejectReason = "";

      order.TR_price = "";
      order.Max_TR_price = String(order.Price);
      order.TR_Price_is_perc = "";
      order.BE_Price = "";
      order.SPL_Order_flag = "N";
      order.ApprovalStatusCode = user.WebCode;
      order.ApprovalTypeCode = ""; // key
      order.StopLossPx = "";
      order.SenderCompanyID = "";
      order.LocalValue = "";
      order.SymbolLongName = "";
      order.LastUpdateTime = "01-01-2000 22:51:14"; //weird

      // order.Sett_Type = ""; //selectedOrder.SettlementType.value
      // order.CustodianID = ""; //selectedOrder.CustodianID.id // CustodianID

      order.Sett_Type = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? "2" : ""; //Mustafa changes
      order.CustodianID = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? props.OrderDetailsData.CustodianId : ""; //Mustafa changes

      order.IP_Address = localStorage.getItem("ipAddress");
      order.Leverage = parseFloat(0);
      order.TradingSessionID = "";

      order.SmartOrderID = ""; // SmartOrderID
      order.SmartOrderType = "4"; // SmartOrderType
      order.lstConditionalParameters = [];
      order.bracketOrdParam = {
        isTakeProfit_MKT: AsMktTakeProfit,
        isTakeProfit: isTakeProfit,
        TakeProfitValue: parseFloat(TPValue),
        TakeProfitValueType: TPSelectedCriteria,
        isStopLoss_MKT: false,
        isStopLoss: false,
        StopLossValue: "0",
        StopLossValueType: "0",
      };

      order.Category = OrderCategory.TakeProfit;
        
      if (props.signalr_connection !== undefined && props.signalr_connection !== null && props.signalr_connection.state === 1) {
        let order1 = order;
        order = [order];

        props.signalr_connection.proxies.myhub.invoke("sendAddBracketOrderPortfolioRequest", localStorage.getItem("username"), order1).then((res) => {
          if (!res) {
            ;
            Helpers.errorNotify(i18n.t("MsgErrNetWork"), i18n.language);
            props.onClose();
          } else {
            if (isStopLoss) {
              let order = {};

              ;
              let user = JSON.parse(localStorage.getItem("user"));
              //let selectedAccount = props.selectedAccount;
              let newDate = new Date();

              let date = Helpers.dateFrommater(newDate);

              let result = props.symbols.find((obj) => {
                return obj.Symbol === props.OrderDetailsData.Symbol;
              });
              if (result !== undefined && result !== null) {
                order.SymbolCode = result.SymbolID;
                order.Exchange = result.Exchange;
                order.Symbol = result.Symbol;
                order.MarketTypeCode = result.MarketType; // symbol.MarketType
              } else {
                order.SymbolCode = "";
                order.Exchange = "";
                order.Symbol = "";
                order.MarketTypeCode = "";
              }

              order.OrderID = "";

              order.BookCode = "0001";
              order.BrokerID = user.BrokerID;
              order.AccountID = props.selectedAccount.AccountID;

              order.Price = String(price);
              order.ValidityCode = "0002";

              order.ValidityDate = Helpers.dateFrommater(new Date(newDate2));

              let total = Quantity;
              let remaining = Quantity;
              let execqty = 0;

              order.TotalVolume = String(total);
              order.Remaining = String(remaining);

              /* order.TotalVolume = String(parseInt(Quantity))
                                order.Remaining = isModify ? remaining : String(parseInt(Quantity)); */
              //
              order.SourceCode = "c";
              order.StatusCode = "M"; //isCancel ? "C" : "W";
              order.EntryDate = date; // bs iza new order
              order.ModifyDate = /* isModify ? */ date; /* : "" */ // bs iza modify order
              order.UserID = user.UCode;
              order.OrigUserID = user.UCode;

              order.Source2Code = "c";
              order.MinFillQty = "0";
              //order.VisibleQty = thisParam.state.VisibleQty;

              order.VisibleQty = "0"; //thisParam.state.selectedExecutionRole === "0020" && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? -1 : thisParam.state.VisibleQty; //Mustafa changes

              order.OrderTypeCode = "2";
              if (order.Price === "0") {
                order.OrderTypeCode = "1";
              }
              order.NIN = props.selectedAccount.NIN;
              order.ProcSentFlag = "Y";
              order.MarketOrderID = "";
              order.OriginCode = "22";
              order.IntOrderID = "";
              order.TP_price = "";
              order.SL_price = "";

              order.TrxnID = "0";

              order.SellBuyFlag = "S";
              order.msgCode = "C10";

              order.AccountNameA = props.selectedAccount.ClientNameA;
              order.AccountNameE = props.selectedAccount.ClientNameE; // account.ClientNameE
              order.Remark = "Cost Price = " + order.Price; // remarks
              order.SenderSubID = "";
              order.BuyerMember = "";
              order.SellerMember = "";
              order.AvgExePrice = "";
              order.IsinCode = ""; // symbol.IsinCode
              order.FIXOrderID = "";
              order.ClientID = props.selectedAccount.ClientID;
              //order.ClientID = props.selectedAccount.AccountID;
              order.RejectReason = "";

              order.TR_price = "";
              order.Max_TR_price = String(order.Price);
              order.TR_Price_is_perc = "";
              order.BE_Price = "";
              order.SPL_Order_flag = "N";
              order.ApprovalStatusCode = user.WebCode;
              order.ApprovalTypeCode = ""; // key
              order.StopLossPx = "";
              order.SenderCompanyID = "";
              order.LocalValue = "";
              order.SymbolLongName = "";
              order.LastUpdateTime = "01-01-2000 22:51:14"; //weird

              // order.Sett_Type = ""; //selectedOrder.SettlementType.value
              // order.CustodianID = ""; //selectedOrder.CustodianID.id // CustodianID

              order.Sett_Type = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? "2" : ""; //Mustafa changes
              order.CustodianID = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? props.OrderDetailsData.CustodianId : ""; //Mustafa changes

              order.IP_Address = localStorage.getItem("ipAddress");
              order.Leverage = parseFloat(0);
              order.TradingSessionID = "";

              order.SmartOrderID = ""; // SmartOrderID
              order.SmartOrderType = "4"; // SmartOrderType

              order.lstConditionalParameters = [];

              order.bracketOrdParam = {
                isStopLoss_MKT: AsMktStopLoss,
                isStopLoss: isStopLoss,
                StopLossValue: parseFloat(STValue),
                StopLossValueType: STSelectedCriteria,
                isTakeProfit_MKT: false,
                isTakeProfit: false,
                TakeProfitValue: 0,
                TakeProfitValueType: "0",
              };
              order.Category = OrderCategory.StopLoss;

              if (props.signalr_connection !== undefined && props.signalr_connection !== null && props.signalr_connection.state === 1) {
                let order1 = order;
                order = [order];

                props.signalr_connection.proxies.myhub.invoke("sendAddBracketOrderPortfolioRequest", localStorage.getItem("username"), order1).then((res) => {
                  if (!res) {
                    ;
                    Helpers.errorNotify(i18n.t("MsgErrNetWork"), i18n.language);
                    props.onClose();
                  } else {
                    Helpers.successNotify(i18n.t("BracketOrderMsg"), i18n.language);
                    props.onClose();
                  }
                });
              } else {
                Helpers.errorNotify(i18n.t("error"), i18n.language);
              }
            } else {
              Helpers.successNotify(i18n.t("BracketOrderMsg"), i18n.language);
              props.onClose();
            }
          }
        });
      } else {
        Helpers.errorNotify(i18n.t("error"), i18n.language);
      }
    } else if (isStopLoss) {
      let order = {};

      let user = JSON.parse(localStorage.getItem("user"));
      //let selectedAccount = props.selectedAccount;
      let newDate = new Date();

      let date = Helpers.dateFrommater(newDate);

      let result = props.symbols.find((obj) => {
        return obj.Symbol === props.OrderDetailsData.Symbol;
      });
      if (result !== undefined && result !== null) {
        order.SymbolCode = result.SymbolID;
        order.Exchange = result.Exchange;
        order.Symbol = result.Symbol;
        order.MarketTypeCode = result.MarketType; // symbol.MarketType
      } else {
        order.SymbolCode = "";
        order.Exchange = "";
        order.Symbol = "";
        order.MarketTypeCode = "";
      }

      order.OrderID = "";

      order.BookCode = "0001";
      order.BrokerID = user.BrokerID;
      order.AccountID = props.selectedAccount.AccountID;

      order.Price = String(price);
      order.ValidityCode = "0002";

      order.ValidityDate = Helpers.dateFrommater(new Date(newDate2));

      let total = Quantity;
      let remaining = Quantity;
      let execqty = 0;

      order.TotalVolume = String(total);
      order.Remaining = String(remaining);

      /* order.TotalVolume = String(parseInt(Quantity))
            order.Remaining = isModify ? remaining : String(parseInt(Quantity)); */
      //
      order.SourceCode = "c";
      order.StatusCode = "M"; //isCancel ? "C" : "W";
      order.EntryDate = date; // bs iza new order
      order.ModifyDate = /* isModify ? */ date; /* : "" */ // bs iza modify order
      order.UserID = user.UCode;
      order.OrigUserID = user.UCode;

      order.Source2Code = "c";
      order.MinFillQty = "0";
      //order.VisibleQty = thisParam.state.VisibleQty;

      order.VisibleQty = "0"; //thisParam.state.selectedExecutionRole === "0020" && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? -1 : thisParam.state.VisibleQty; //Mustafa changes

      order.OrderTypeCode = "2";
      if (order.Price === "0") {
        order.OrderTypeCode = "1";
      }
      order.NIN = props.selectedAccount.NIN;
      order.ProcSentFlag = "Y";
      order.MarketOrderID = "";
      order.OriginCode = "22";
      order.IntOrderID = "";
      order.TP_price = "";
      order.SL_price = "";

      order.TrxnID = "0";

      order.SellBuyFlag = "S";
      order.msgCode = "C10";

      order.AccountNameA = props.selectedAccount.ClientNameA;
      order.AccountNameE = props.selectedAccount.ClientNameE; // account.ClientNameE
      order.Remark = "Cost Price = " + order.Price; // remarks
      order.SenderSubID = "";
      order.BuyerMember = "";
      order.SellerMember = "";
      order.AvgExePrice = "";
      order.IsinCode = ""; // symbol.IsinCode
      order.FIXOrderID = "";
      order.ClientID = props.selectedAccount.ClientID;
      //order.ClientID = props.selectedAccount.AccountID;
      order.RejectReason = "";

      order.TR_price = "";
      order.Max_TR_price = String(order.Price);
      order.TR_Price_is_perc = "";
      order.BE_Price = "";
      order.SPL_Order_flag = "N";
      order.ApprovalStatusCode = user.WebCode;
      order.ApprovalTypeCode = ""; // key
      order.StopLossPx = "";
      order.SenderCompanyID = "";
      order.LocalValue = "";
      order.SymbolLongName = "";
      order.LastUpdateTime = "01-01-2000 22:51:14"; //weird

      // order.Sett_Type = ""; //selectedOrder.SettlementType.value
      // order.CustodianID = ""; //selectedOrder.CustodianID.id // CustodianID

      order.Sett_Type = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? "2" : ""; //Mustafa changes
      order.CustodianID = localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "EGYPT" ? props.OrderDetailsData.CustodianId : ""; //Mustafa changes

      order.IP_Address = localStorage.getItem("ipAddress");
      order.Leverage = parseFloat(0);
      order.TradingSessionID = "";

      order.SmartOrderID = ""; // SmartOrderID
      order.SmartOrderType = "4"; // SmartOrderType

      order.lstConditionalParameters = [];

      order.bracketOrdParam = {
        isStopLoss_MKT: AsMktStopLoss,
        isStopLoss: isStopLoss,
        StopLossValue: parseFloat(STValue),
        StopLossValueType: STSelectedCriteria,
        isTakeProfit_MKT: false,
        isTakeProfit: false,
        TakeProfitValue: 0,
        TakeProfitValueType: "0",
      };

      if (props.signalr_connection !== undefined && props.signalr_connection !== null && props.signalr_connection.state === 1) {
        let order1 = order;
        order = [order];

        props.signalr_connection.proxies.myhub.invoke("sendAddBracketOrderPortfolioRequest", localStorage.getItem("username"), order1).then((res) => {
          if (!res) {
            ;
            Helpers.errorNotify(i18n.t("MsgErrNetWork"), i18n.language);
            props.onClose();
          } else {
            Helpers.successNotify(i18n.t("BracketOrderMsg"), i18n.language);
            props.onClose();
          }
        });
      } else {
        Helpers.errorNotify(i18n.t("error"), i18n.language);
      }
    }
  }

  function validate() {
    ;
    if (Quantity === "" || Quantity === null || Quantity === "0" || parseInt(Quantity) <= 0) {
      Helpers.errorNotify(i18n.t("quantity_is_required"));
      return false;
    }
    if (parseInt(Quantity) > parseInt(props.OrderDetailsData.Qty)) {
      Helpers.errorNotify(i18n.t("visiblequantitymustbelessthanquantity"));
      return false;
    }
    if (price === "") {
      Helpers.errorNotify(i18n.t("priceisrequired"));
      return false;
    }

    if (!isStopLoss && !isTakeProfit) {
      Helpers.errorNotify(i18n.t("Error"));
      return false;
    }
    if (isTakeProfit && TPValue === "") {
      Helpers.errorNotify(i18n.t("Enter value"));
      return false;
    }
    if (isStopLoss && STValue === "") {
      Helpers.errorNotify(i18n.t("Enter value"));
      return false;
    }
    return true;
  }
  // function onChangeValidityDate  (event, value = null, validityDate = null) {

  //     let paramValidityDateId = null;

  //     if (value === null) {
  //         paramValidityDateId = event.target.value;
  //     } else {
  //         paramValidityDateId = value;
  //     }

  //     this.state.validityDateTypes.forEach((item) => {
  //         if (item.ID === paramValidityDateId) {
  //             this.setState({ selectedValidityDateType: item }, () => {
  //                 Helpers.validityDateChecker(this, validityDate);
  //             });
  //         }
  //     });
  // };

  // const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
  const mobile = Boolean(userAgent.match(/iPhone/i));
  return (
    <div className="TakeProfit&StopLossBox ml-3 mr-3">
      {/* <select
                className="sub-header-dropdown b mt-1"
                style={{ width: "93%"  }}
                name="BracketOrderDropdownBuyOrderPopup"
                id="BracketOrderDropdownBuyOrderPopup"
                defaultValue="DEFAULT"
                onChange={(e) => setBracketOrderSelected(e.target.value)}
                value={BracketOrderSelected}
                tabIndex="1"
            >
                <option value="1">{i18n.t("LastTrade")}</option>
                <option value="2">{i18n.t("closeprice")}</option>
                <option value="3">{i18n.t("Profit")} & {i18n.t("Loss")} </option>
            </select> */}
      <strong className="b mt-1" style={{ width: "93%" }} name="BracketOrderDropdownBuyOrderPopup" id="BracketOrderDropdownBuyOrderPopup" defaultValue="DEFAULT">
        {i18n.t("symbol") + " : " + SymbolSelected}
      </strong>

      <div className="mt-1" style={{ display: "flex", width: "100%" }}>
        <div className="TakeProfit-Checkbox mt-1">
          <input type="checkbox" style={{ width: "11px", height: "11px" }} className="checkbox" checked={isTakeProfit} onChange={(e) => setIsTakeProfit(!isTakeProfit)} />
          <strong style={{ paddingInline: "2px" }}>{i18n.t("Takeprofit")}</strong>
        </div>
        <input
          className="sub-header-dropdown  mt-1 ml-3 mr-3"
          style={{ marginLeft: "0px", paddingInline: "5px" }}
          type="number"
          pattern="[0-9]*"
          step=".01"
          min="0"
          id="TakeProfitValueOrderEntryPopup"
          name="TakeProfitValueOrderEntryPopup"
          placeholder={i18n.t("value")}
          value={TPValue}
          tabIndex="2"
          onChange={(e) => {
            let v = "";

            if (e.target.value >= 0 && e.target.value !== "") {
              v = e.target.value.toString();
            } else if (e.target.value === "") {
              v = "";
            }
            setTPValue(v);
          }}
        />
        <select
          className="sub-header-dropdown  mt-1"
          style={{ marginLeft: "0px" }}
          name="TakeProfitDropdownBuyOrderPopup"
          id="TakeProfitDropdownBuyOrderPopup"
          defaultValue="DEFAULT"
          onChange={(e) => setTPSelectedCriteria(e.target.value)}
          value={TPSelectedCriteria}
          tabIndex="3">
          {/* <option value="0" selected></option> */}
          {/* {BracketOrderSelected === "1" || BracketOrderSelected === "2" ? <option value="1">{i18n.t("value")}</option> : null} */}
          <option value="0">{i18n.t("price")}</option>
          <option value="1">{i18n.t("value")}</option>
          <option value="2">{i18n.t("percentage")}</option>
        </select>

        <div className="TakeProfit-Checkbox mt-2" style={{ paddingInline: "8px" }}>
          <input type="checkbox" style={{ width: "11px", height: "11px" }} className="checkbox" checked={AsMktTakeProfit} onChange={(e) => setAsMktTakeProfit(!AsMktTakeProfit)} />
          <strong style={{ paddingInline: "2px" }}>{i18n.t("AsMkt")}</strong>
        </div>
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div className="StopLoss-Checkbox mt-1">
          <input type="checkbox" style={{ width: "11px", height: "11px" }} className="checkbox" checked={isStopLoss} onChange={(e) => setIsStopLoss(!isStopLoss)} />
          <strong style={{ paddingInline: "2px" }}>{i18n.t("Stoploss")}</strong>
        </div>
        <input
          className="sub-header-dropdown mt-1 ml-3 mr-3"
          style={{ marginLeft: "0px", paddingInline: "5px" }}
          type="number"
          pattern="[0-9]*"
          step=".01"
          min="0"
          id="StopLossValueOrderEntryPopup"
          name="StopLossValueOrderEntryPopup"
          placeholder={i18n.t("value")}
          value={STValue}
          tabIndex="4"
          onChange={(e) => {
            let v = "";

            if (e.target.value >= 0 && e.target.value !== "") {
              v = e.target.value.toString();
            } else if (e.target.value === "") {
              v = "";
            }
            setSTValue(v);
          }}
        />
        <select
          className="sub-header-dropdown  mt-1"
          style={{ marginLeft: "0px" }}
          name="StoplossDropdownBuyOrderPopup"
          id="StoplossDropdownBuyOrderPopup"
          defaultValue="DEFAULT"
          onChange={(e) => setSTSelectedCriteria(e.target.value)}
          value={STSelectedCriteria}
          tabIndex="5">
          {/* <option value="0" selected></option> */}
          {/* {BracketOrderSelected === "1" || BracketOrderSelected === "2" ? <option value="1">{i18n.t("value")}</option> : null} */}
          <option value="0">{i18n.t("price")}</option>
          <option value="1">{i18n.t("value")}</option>
          <option value="2">{i18n.t("percentage")}</option>
        </select>
        <div className="StopLoss-Checkbox mt-2" style={{ paddingInline: "8px" }}>
          <input type="checkbox" style={{ width: "11px", height: "11px" }} className="checkbox" checked={AsMktStopLoss} onChange={(e) => setAsMktStopLoss(!AsMktStopLoss)} />
          <strong style={{ paddingInline: "2px" }}>{i18n.t("AsMkt")}</strong>
        </div>
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div className="mt-2" style={{ width: "23%" }}>
          <strong>{i18n.t("quantity")}</strong>
        </div>
        <input
          className="sub-header-dropdown  mt-2"
          style={{ marginLeft: "0px", paddingInline: "5px", width: "71%" }}
          type="text"
          id="quantityOrderEntryPopup"
          name="quantityOrderEntryPopup"
          value={Helpers.numberFormatterWithCommas(Quantity)}
          tabIndex="6"
          onChange={(e) => {
            let quantity = 0;

            var isnan = /^[0-9,.]*$/.test(e.target.value);

            if (!isnan) e.target.value = "";

            if (e.target.value === "") {
              quantity = 0;
            } else {
              quantity = Number(e.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "").replace(",", "")).toString();
            }

            setQuantity(quantity);
          }}
        />
      </div>

      {/* <div style={{ display: "flex", width: "100%" }}>
                <div className='mt-2' style={{ width: "23%" }}>
                    <strong>{i18n.t("price")}</strong>
                </div>
                {mobile ?
                    <input

                        className="sub-header-dropdown mt-2"
                        style={{ marginLeft: "0px", paddingInline: "5px", width: "71%" }}
                        type="text"
                        // pattern="[0-9]*"
                        step=".01"
                        min="0"
                        id="priceOrderEntryPopup"
                        name="priceOrderEntryPopup"
                        placeholder={i18n.t("price")}
                        value={price}
                        tabIndex="7"
                        onChange={(e) => {
                            let price = "";
                            let priceValueInput = e.target.value;

                            // const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;

                            // // const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));  
                            // const mobile = Boolean(userAgent.match(/iPhone|iPad/i));

                            var isnan = /^[0-9.]*$/.test(priceValueInput);

                            if (!isnan)
                                priceValueInput = '';

                            if (priceValueInput === '') {
                                price = ''
                            } else {
                                price = Number(priceValueInput.toString().replace(',', '').replace(',', '').replace(',', '').replace(',', '').replace(',', '')).toString();
                            }


                            if (e.target.value >= 0 && e.target.value !== "") {
                                price = e.target.value.toString();
                            } else if (e.target.value === "") {
                                price = "";
                            }
                            setPrice(price);
                        }}
                    />

                    :

                    <input

                        className="sub-header-dropdown  mt-2"
                        style={{ marginLeft: "0px", paddingInline: "5px", width: "71%" }}
                        type="text"
                        // pattern="[0-9]*"
                        step=".01"
                        min="0"
                        id="priceOrderEntryPopup"
                        name="priceOrderEntryPopup"
                        placeholder={i18n.t("price")}
                        value={price}
                        tabIndex="8"
                        onChange={(e) => {
                            let price = "";
                            let priceValueInput = e.target.value;

                            // const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;

                            // // const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));  
                            // const mobile = Boolean(userAgent.match(/iPhone|iPad/i));

                            var isnan = /^[0-9.]*$/.test(priceValueInput);

                            if (!isnan)
                                priceValueInput = '';

                            if (priceValueInput === '') {
                                price = ''
                            } else {
                                price = Number(priceValueInput.toString().replace(',', '').replace(',', '').replace(',', '').replace(',', '').replace(',', '')).toString();
                            }


                            if (e.target.value >= 0 && e.target.value !== "") {
                                price = e.target.value.toString();
                            } else if (e.target.value === "") {
                                price = "";
                            }
                            setPrice(price);
                        }}
                    />
                }
            </div> */}

      {/* <div style={{ display: "flex", width: "100%" }}>
                <div className='mt-2' style={{ width: "23%" }}>
                    <strong>{this.props.t("validity")}</strong>
                </div>
                <select
                    className="sub-header-dropdown buy-order-input mt-1"
                    style={{ marginLeft: "0px" }}
                    name="validityDateBuyOrderPopup"
                    id="validityDateBuyOrderPopup"
                    defaultValue="DEFAULT"
                    onChange={this.onChangeValidityDate}
                    disabled={this.state.isValidityDateDisabled}
                    value={this.state.selectedValidityDateType.ID}
                    tabIndex={7}
                >
                    {this.state.validityDateTypes.map((obj) => {
                        return (
                            <option value={obj.ID}>
                                {this.props.i18n.language === "en"
                                    ? obj.DescE
                                    : obj.DescA}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
                <div className='mt-2' style={{ width: "23%" }}>
                    <strong>{this.props.t("validitydate")}</strong>
                </div>
                <div className="mt-1" tabIndex={8} dir="ltr">
                    <DatePicker
                        onChange={(date) => {
                            this.setState({ validityDate: date }, () => {
                                //this.callGetTradeconfirmation();
                            });
                        }}
                        value={this.state.validityDate}
                        // minDate={exDate}
                        format="dd/MM/yyyy"
                        disabled={this.state.isValidityDatePickerDisabled}
                        clearIcon={null}
                    />
                </div>
            </div> */}
      <button
        /* tabIndex={4} */
        className="btn custom-btn-primary ml-auto mr-auto btn-focus-custom btn-trade-orderPopup mt-3 "
        style={{ width: "95%" }}
        // disabled={
        //     !Helpers.getComponentPermission(
        //         this.props.permData,
        //         this.state.orderType === "B"
        //             ? Constants.ComponentChildCode.Buy_Orders_Entry
        //             : Constants.ComponentChildCode.Sell_Orders_Entry,
        //         this.state.orderType === "B" ? "160" : "150",
        //         true
        //     )
        // }
        onClick={() => callAddOrder()}>
        {i18n.t("submit")}
      </button>
    </div>
  );
}

export default BracketOrdersPopup;
